'use strict';

import 'angular';

import formModule from '../form';
import directive from './directive';

const MODULE_NAME = 'brg.rest.proxyField';

var app = angular.module(MODULE_NAME, [
	formModule
]);
app.directive('brgRestProxyField', directive);

export default MODULE_NAME;
